export default __webpack_public_path__ + "static/media/slide7.aed6c7a6.jpg";